import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Typography } from 'rmwc/Typography';
import { Card } from 'rmwc/Card';
import * as api from '../../api/api';

class UserRenderIndividualRoadmapAll extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
            propsData: {
                certificationParticipationId: '',
                levelId:'',
                trackId:''
            },
        	data: {
        		levelName: ''
        	},
        	roadmapDetails: []
    	};
    }

    handleRMView = (e, roadmapId, roadmapName) => {
        this.props.onhandleRMView(this.props.roadmapId, this.props.roadmapName)
    }

    componentDidMount() {
    }

    render() {
    	let individualComponent
        let handleRMView = this.handleRMView

        individualComponent = (
            <div>
                <GridCell span="12">
                    <Card style={{padding: '5px'}}>
                        <Grid className="opportunity-list-item">
                            <GridCell span="9">
                                {this.props.roadmapName}
                            </GridCell>
                            <GridCell span="3">
                                <button className="mdc-button" align = "right" aria-label="Favorite" onClick= {((e) => handleRMView(e, this.props.roadmapId, this.props.roadmapName))}>
                                    View
                                </button>
                            </GridCell>
                        </Grid>
                    </Card>
                </GridCell>
            </div>
        )

    	return (
            <div>
                {individualComponent}
            </div>
    	)
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserRenderIndividualRoadmapAll);


// WEBPACK FOOTER //
// ./src/views/roadmap/UserRenderIndividualRoadmapAll.jsx